export { Title } from './components/title';
export { Body } from './components/body';
export { Intro } from './components/intro';
export { Caption } from './components/caption';

export type TitleTag = 'header' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'span';
export type TextTag = 'article' | 'div' | 'p' | 'time' | TitleTag;

export enum Size {
  xlarge = 'text-body-xlarge',
  large = 'text-body-large',
  medium = 'text-body-medium',
  small = 'text-body-small',
}

export enum Variant {
  regular = 'font-normal',
  semibold = 'font-semibold',
}
